import Axios from "./axios";

class DocumentationsApi extends Axios {
  constructor() {
    const baseURL = process.env.VUE_APP_ECO_DOCUMENTATIONS_API_URL;
    const apiToken = process.env.VUE_APP_ECO_DOCUMENTATIONS_API_TOKEN;

    super({
      baseURL,
      headers: {
        token: apiToken
      }
    });
  }

  //users
  getUser(id) {
    return this.call("/users/" + id, "GET");
  }

  deleteUser(id) {
    return this.call("/users/" + id, "DELETE");
  }

  getUsers(data) {
    return this.call("/users", "GET", data);
  }

  createUser({ name, login, password, partner }) {
    return this.call("/users", "POST", { name, login, password, partner });
  }

  updateUser({ id, name, login, password, partner }) {
    return this.call(`/users/${id}`, "PUT", {
      name,
      login,
      password,
      partner
    });
  }

  // Documentations
  getDocumentations(data) {
    return this.call("/documentations", "GET", data);
  }

  // Documentations
  createUserDocumentationAccess({ user_id, documentation_id, status }) {
    return this.call(`/users/${user_id}/documentations`, "POST", {
      documentation_id,
      status
    });
  }
  // Documentations
  revokeUserDocumentationAccess({ user_id, documentation_id }) {
    return this.call(`/users/${user_id}/documentations`, "DELETE", {
      documentation_id
    });
  }
}

export default new DocumentationsApi();
